export const toastContainerStyles = {
  position: 'fixed',
  bottom: 24,
  right: 24,
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  zIndex: 9999,
  pointerEvents: 'none',
};

export const toastItemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '10px 16px',
  borderRadius: ({ shape }) => shape.radius.m,
  backgroundColor: ({ palette }) => palette.background.secondary,
  border: ({ palette }) => `1px solid ${palette.divider}`,
  boxShadow: ({ palette }) => palette.shadow.m,
  pointerEvents: 'auto',
  animation: 'presenceToastFadeIn 0.3s ease-in-out',

  '@keyframes presenceToastFadeIn': {
    from: { opacity: 0, transform: 'translateX(20px)' },
    to: { opacity: 1, transform: 'translateX(0)' },
  },
};

export const avatarStyles = {
  width: 28,
  height: 28,
  fontSize: '12px',
};

export const getToastAvatarBorderStyles = userColor => ({
  border: `2px solid ${userColor}`,
});
